import { api } from "./api";
import { toast } from "sonner";

export async function confirmDeleteTable(t) {
  const paidCount = t.members.filter(m => m.paid).length;
  const warn = paidCount ? `\n\nATTENZIONE: ${paidCount} caparre già pagate (non rimborsabili).` : "";
  if (!window.confirm(`Eliminare il tavolo "${t.name}"?${warn}`)) return false;
  try {
    await api.delete(`/tables/${t.id}`);
    toast.success("Tavolo eliminato");
    return true;
  } catch (e) {
    toast.error(e.response?.data?.detail || "Errore");
    return false;
  }
}
